const elPromoCode = {
  isFree:false,
  load:function(formID,invoiceID,eventHash){
    this.invoiceHolder = document.getElementById(invoiceID);
    this.form = document.getElementById(formID);
    this.input = this.form.querySelector("input");
    this.eventHash = eventHash;
    this.events();
  },
  events:function(){
    this.form.addEventListener("submit",(e)=>{
      e.preventDefault();
      this.verify();
    });
  },
  save:function(){
    this.promoCode = this.input.value;
    if(!this.promoCode || this.promoCode == "") return;
    let ajaxURLPromo = ELAJAX.url+"payment/promocode/"+this.eventHash;

      fetch(ajaxURLPromo,{
        method:"POST",
        headers:{
          "Content-Type":"application/json",
          "Accept":"application/json"
        },
        body:JSON.stringify({
          eventHash:this.eventHash,
          calendarID:ELAJAX.calendarID, 
          'userid':hh2020Login.userData.id,
          promoCode:this.promoCode,
        })
      });
  },
  verify:function(){
    this.promoCode = this.input.value;
    elLoader.show("Verifying Promo Code");
    fetch(ELAJAX.url+"payment/promocode/",{
      method:"POST",
      headers:{
        'Accept':'application/json',
        'Content-Type':'application/json'
      },
      body:JSON.stringify({
          'id':hh2020Login.userData.id,
          'token':hh2020Login.userData.token,
          'promoCode':this.promoCode,
          'eventHash':this.eventHash,
          calendarID:ELAJAX.calendarID,
          'plan':PLANID
      })
    }).then(res=>res.json())
    .then(data=>{
      if(data.error){
        elLoader.hide();
        alert(data.message);
      }
      else{
        elLoader.hide();
        this.showDiscount(data);
      }
      this.showDiscount(data);
    });
  },
  showDiscount:function(data){
    var discountHolder = this.invoiceHolder.querySelector(".discount");
    if(data.grandTotal == 0){
      this.isFree = true;
      document.getElementById("paymentElement").style.display = "none";
      document.getElementById("paymentSubmit").innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Arrow Forward Circle</title><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M262.62 336L342 256l-79.38-80M330.97 256H170"></path><path d="M256 448c106 0 192-86 192-192S362 64 256 64 64 150 64 256s86 192 192 192z" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="32"></path></svg>POST LISTING';
    }
    else{
      this.isFree = false;
      document.getElementById("paymentElement").style.display = "block";
      document.getElementById("paymentSubmit").innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Arrow Forward Circle</title><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M262.62 336L342 256l-79.38-80M330.97 256H170"></path><path d="M256 448c106 0 192-86 192-192S362 64 256 64 64 150 64 256s86 192 192 192z" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="32"></path></svg>SUBMIT PAYMENT';
    }

    if(data.discount){
      discountHolder.innerHTML = '<div class="description">'+data.discount.description+'</div><div class="subtotal">-$'+data.discount.amount.toFixed(2)+'</div>';
      this.invoiceHolder.querySelector(".grandTotalAmount").innerHTML = "$"+data.grandTotal.toFixed(2);

    }
    else{
      discountHolder.innerHTML = "";
    }
    this.invoiceHolder.querySelector(".grandTotalAmount").innerHTML = "$"+data.grandTotal.toFixed(2);

    var recurringTotals = document.querySelectorAll(".stripe_recurringTotal");
    recurringTotals.forEach(r=>{
      r.innerText = data.recurringTotal.toFixed(2);
    });

    if(this.isFree){
      document.getElementById("disclaimerCheckbox").querySelector("input").checked = true;
      document.getElementById("disclaimerCheckbox").style.display = "none";
      

    }

  }
}
